import { useCallback } from 'react'

import ScAnalytics from 'classes/sc_analytics'

const useSendMetric = ({ page, label }) => {
  return useCallback(() => ScAnalytics.sendClickButton(label, 'Footer', page), [page, label])
}

export default useSendMetric
